import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SignedIn, SignedOut, RedirectToSignIn } from "@clerk/clerk-react";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import { Dashboard } from "@/features/dashboard";
import {
  CreateInvoice,
  InvoiceHistory,
  InvoicePreview,
  PublicInvoiceView,
} from "@/features/customer-invoices";
import { ChatwootDashboardApp, RazorpayLinks } from "@/features/integrations";
import { RiderMaster, StaffMaster, VendorMaster } from "@/features/masters";
import { ActiveOrders, OrderDetail, OrderSignPage, PayeeQueue } from "@/features/ops-orders";
import { RiderDashboard, RiderLogin, RiderTripLogs } from "@/features/rider-app";
import {
  CreateVendorInvoice,
  MerchantSignPage,
  VendorInvoiceHistory,
  VendorInvoicePreview,
} from "@/features/vendor-invoices";

function ProtectedRoute({ children }) {
  return (
    <>
      <SignedIn>{children}</SignedIn>
      <SignedOut><RedirectToSignIn /></SignedOut>
    </>
  );
}

function App() {
  return (
    <div className="app-container">
      <BrowserRouter>
        <Routes>
          {/* Main app routes with layout — protected by Clerk */}
          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route path="/" element={<Dashboard />} />
            {/* Orders / Ops */}
            <Route path="/orders" element={<ActiveOrders />} />
            <Route path="/orders/:id" element={<OrderDetail />} />
            {/* Customer Invoice Routes */}
            <Route path="/create" element={<CreateInvoice />} />
            <Route path="/invoice/:id" element={<InvoicePreview />} />
            <Route path="/history" element={<InvoiceHistory />} />
            {/* Vendor Invoice Routes */}
            <Route path="/vendors" element={<VendorMaster />} />
            <Route path="/staff" element={<StaffMaster />} />
            <Route path="/riders" element={<RiderMaster />} />
            <Route path="/rider-logs" element={<RiderTripLogs scope="admin" />} />
            <Route path="/payee-queue" element={<PayeeQueue />} />
            <Route path="/vendor-invoice" element={<CreateVendorInvoice />} />
            <Route path="/vendor-invoice/:id" element={<VendorInvoicePreview />} />
            <Route path="/vendor-history" element={<VendorInvoiceHistory />} />
            {/* Chatwoot Route */}
            <Route path="/chatwoot" element={<ChatwootDashboardApp />} />
            {/* Razorpay Payment Links */}
            <Route path="/razorpay" element={<RazorpayLinks />} />
          </Route>
          {/* Public pages (no layout, no auth) */}
          <Route path="/sign/:token" element={<MerchantSignPage />} />
          <Route path="/order-sign/:token" element={<OrderSignPage />} />
          <Route path="/pay/:id" element={<PublicInvoiceView />} />
          {/* Rider app (mobile, no layout, no auth) */}
          <Route path="/rider" element={<RiderLogin />} />
          <Route path="/rider/dashboard" element={<RiderDashboard />} />
          <Route path="/rider/trips" element={<RiderTripLogs scope="rider" />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
